import React from 'react';
import { Text } from '../Text/Text';
import {
  ListItemIcon,
  ListItemIconSpacer,
  ListItemVariant,
  ListItemText,
  ListItemWrapperProps,
} from './ListItem.styles';
import { Box } from '../Box/Box';
import { Wrapper } from '../Wrapper/Wrapper';

export interface ListItemProps extends ListItemWrapperProps {
  variant?: ListItemVariant;
  subText?: string;
  icon?: string;
  disabled?: boolean;
  /** Reserve icon column width when no icon is provided */
  preserveIconSpace?: boolean;
}

export const ListItem: React.FC<ListItemProps> = ({
  variant = 'default',
  subText,
  icon,
  disabled,
  preserveIconSpace,
  children,
  ...rest
}) => {
  return (
    <Wrapper {...rest}>
      <Box display="flex">
        {icon && <ListItemIcon variant={variant} disabled={disabled} className={`${icon} fa-fw`} />}
        {!icon && preserveIconSpace && <ListItemIconSpacer />}

        <Box flexGrow={1}>
          <ListItemText variant={variant} disabled={disabled}>
            {children}
          </ListItemText>

          {subText && (
            <Text fontSize="small" color={disabled ? 'neutral.400' : 'neutral.500'}>
              {subText}
            </Text>
          )}
        </Box>
      </Box>
    </Wrapper>
  );
};
